import { Colors } from '@common/components/foundations/colorVariants';

interface Status {
  label: string;
  bgColor?: Colors;
}

const StatusList: Record<number, Status> = {
  1: { label: 'Scheduled', bgColor: 'indigo' },
  2: { label: 'In progress', bgColor: 'orange' },
  3: { label: 'Success', bgColor: 'darkGreen' },
  4: { label: 'Error', bgColor: 'uiRed' },
  5: { label: 'Revoked', bgColor: 'darkGrey' }
};

export const getStatusDetails = (statusCode: number): Status => {
  const status = StatusList[statusCode];
  if (status) {
    return {
      label: status.label,
      bgColor: status.bgColor
    };
  }
  // Default values if status code is not found in the list
  return {
    label: 'Unknown',
    bgColor: 'darkGrey'
  };
};
